import { render, staticRenderFns } from "./ShareToTeamForEdit.vue?vue&type=template&id=4a71723d&scoped=true&"
import script from "./ShareToTeamForEdit.vue?vue&type=script&lang=js&"
export * from "./ShareToTeamForEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShareToTeamForEdit.vue?vue&type=style&index=0&id=4a71723d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71723d",
  null
  
)

export default component.exports